import { Box, Button, Divider, IconButton, Typography } from "@mui/material";
import React, { useRef } from "react";
import info1 from "../images/info1.png";
import info2 from "../images/info2.png";
import info3 from "../images/info3.png";
import info4 from "../images/info4.png";
import info5 from "../images/info5.png";
import info6 from "../images/info6.png";
import locationIcon from "../images/PlaceMarker.png";
import whatsAppIcon from "../images/whatsAppIcon.png";
import instagramIcon from "../images/instaIcon.png";
import facebookIcon from "../images/fbIcon.png";
import wwwIcon from "../images/wwwIcon.png";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import phoneCall from "../images/mingcute_phone-call-line.png";
import downLeft from "../images/down-left-icon 1.png";
import indLogo from "../images/IndLogo4x.png";
import gpStore from "../images/gpStore.png";
import apStore from "../images/apStore.png";
const SocialIcon = ({ icon, sx, src }) => (
    <a
        href={src}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "inline-flex" }}
    >
        <IconButton
            sx={{
                width: 40,
                height: 40,
                bgcolor: "white",
                borderRadius: "20px",
                boxShadow: "0px 1px 16px 10px #c8c8c840",
                ...sx,
            }}
        >
            {icon}
        </IconButton>
    </a>
);
export const Info = () => {
    const sliderRef = useRef(null);

    const handleSlide = (direction) => {
        const scrollAmount = 300;
        if (sliderRef.current) {
            if (direction === "left") {
                sliderRef.current.scrollLeft -= scrollAmount;
            } else if (direction === "right") {
                sliderRef.current.scrollLeft += scrollAmount;
            }
        }
    };
    return (
        <Box display="flex" justifyContent="center" width="100%" bgcolor="white">
            <Box
                width={375}
                height={812}
                position="relative"
                bgcolor="white"
                overflow="hidden"
            >
                <Box
                    position="absolute"
                    width={727}
                    height={320}
                    top={-157}
                    left={-203}
                    bgcolor="#fff9f9"
                    borderRadius="50%"
                    border="1px solid #ffd0a8"
                >
                    <img
                        src={indLogo}
                        style={{
                            width: "240px",
                            height: "77px",
                            top: "201px",
                            left: "275px",
                            position: "absolute",
                        }}
                    />
                </Box>
                <Box
                    position="absolute"
                    top={170}
                    left="50%"
                    sx={{
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%'
                    }}
                >
                    <Typography
                        fontFamily="Montserrat, sans-serif"
                        fontWeight="700"
                        fontSize={15}
                        textAlign="center"
                        mb={1}
                    >
                        Download The App Now
                    </Typography>
                    <img
                        src={downLeft}
                        alt="Download"
                        style={{
                            width: "30px",
                            height: "30px",
                            margin: '0 auto'
                        }}
                    />
                </Box>

                <a href="https://play.google.com/store/apps/details?id=com.indmatrimony.ind_matrimony">
                    <img
                        src={gpStore}
                        alt=""
                        style={{
                            position: "absolute",
                            width: "130px",
                            height: "38px",
                            top: "240px",
                            left: "52px",

                        }}
                    />
                </a>
                <a href="https://apps.apple.com/in/app/ind-matrimony/id6741297825">
                <img
                    src={apStore}
                    alt=""
                    style={{
                        position: "absolute",
                        width: "130px",
                        height: "38px",
                        top: "240px",
                        left: "195px",
                    }}
                />
                </a>
                <Typography
                    position="absolute"
                    top={283}
                    left={85}
                    fontFamily="Montserrat, sans-serif"
                    fontWeight="700"
                    fontSize={20}
                    sx={{
                        background:
                            "linear-gradient(180deg, rgb(255,119,5) 0%, rgb(230,0,0) 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    Stay Connected with
                </Typography>
                <Typography
                    position="absolute"
                    top={313}
                    left={125}
                    fontFamily="Montserrat, sans-serif"
                    fontWeight="700"
                    fontSize={16}
                    sx={{
                        background:
                            "linear-gradient(180deg, rgb(255,119,5) 0%, rgb(230,0,0) 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    IND Matrimony!
                </Typography>

                <Box
                    position="absolute"
                    top={367}
                    left={0}
                    width="100%"
                    display="flex"
                    justifyContent="center"
                    gap={1}
                >
                    {/* First Button */}
                    <Button
                        component='a'
                        href="tel:8600999372"
                        sx={{
                            width: "150px",
                            height: "40px",
                            background: "linear-gradient(180deg, #FE2411 0%, #AA0104 100%)",
                            color: "white",
                            borderRadius: "20px",
                            textTransform: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "8px",
                            padding: "0 16px",
                            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                            "&:hover": {
                                background: "linear-gradient(180deg, #E60000 0%, #FF7705 100%)",
                            },
                        }}
                    >
                        <img
                            src={phoneCall}
                            alt="phone"
                        //   style={{ width: "16px", height: "16px" }}
                        />
                        <Box display="flex" flexDirection="column" alignItems="flex-start">
                            <Typography fontSize={8} fontWeight="bold" lineHeight={1}>
                                CALL US NOW!
                            </Typography>
                            <Typography fontSize={13} fontWeight="bold">
                                8600999372
                            </Typography>
                        </Box>
                    </Button>

                    {/* Second Button with Phone Number */}
                    <Button
                        component='a'
                        href="tel:8600555740"
                        sx={{
                            width: "150px",
                            height: "40px",
                            background: "linear-gradient(180deg, #FE2411 0%, #AA0104 100%)",
                            color: "white",
                            borderRadius: "20px",
                            textTransform: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "8px",
                            padding: "0 16px",
                            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                    >
                        <img
                            src={phoneCall}
                            alt="phone"
                        //   style={{ width: "16px", height: "16px" }}
                        />
                        <Box display="flex" flexDirection="column" alignItems="flex-start">
                            <Typography fontSize={8} fontWeight="bold" lineHeight={1}>
                                CALL US NOW!
                            </Typography>
                            <Typography fontSize={13} fontWeight="bold">
                                8600555740
                            </Typography>
                        </Box>
                    </Button>
                </Box>
                <Box position="absolute" width={230} height={13} top={440} left={64}>
                    <Typography
                        position="center"
                        // width={109}
                        top={0.5}
                        left={100}
                        fontFamily="Montserrat, sans-serif"
                        fontWeight="600"
                        color="#4e4d4d"
                        fontSize={15}
                    >
                        Visit Our Website
                    </Typography>
                    <Typography
                        component="a"
                        href="https://indmatrimony.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        position="center"
                        // width={113}
                        top={-2}
                        // left={190}
                        fontFamily="Montserrat, sans-serif"
                        fontWeight="700"
                        fontSize={19}
                        sx={{
                            background:
                                "linear-gradient(180deg, rgb(230,0,0) 0%, rgb(255,119,5) 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        https://indmatrimony.in/
                    </Typography>
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        width: 375,
                        height: "auto",
                        top: 695,
                        left: 0,
                        objectFit: "cover",
                    }}
                />
                <Box position="absolute" width={400} height={26} top={740}>
                    <Divider sx={{ my: 2, borderColor: "black" }} />
                </Box>
                <Box
                    position="absolute"
                    top={520}
                    left={0}
                    width="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    overflow="hidden"
                >
                    {/* Left Arrow */}
                    <IconButton
                        sx={{
                            position: "absolute",
                            left: -10,
                            zIndex: 1,
                            bgcolor: "transparent",
                            color: "#E60000",
                        }}
                        onClick={() => handleSlide("left")}
                    >
                        <ArrowBack style={{ color: "black", marginBottom: "15px" }} />
                    </IconButton>

                    {/* Image Slider */}
                    <Box
                        ref={sliderRef}
                        display="flex"
                        gap={2}
                        sx={{
                            overflowX: "scroll",
                            scrollSnapType: "x mandatory",
                            scrollBehavior: "smooth",
                            width: "100%",
                            padding: "10px 0",
                        }}
                    >
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info1})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info4})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info2})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info5})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info3})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 120,
                                height: 132,
                                backgroundImage: `url(${info6})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                    </Box>

                    {/* Right Arrow */}
                    <IconButton
                        sx={{
                            position: "absolute",
                            right: -10,
                            zIndex: 1,
                            bgcolor: "transparent",
                            color: "#E60000",
                        }}
                        onClick={() => handleSlide("right")}
                    >
                        <ArrowForward style={{ color: "black", marginBottom: "15px" }} />
                    </IconButton>
                </Box>
                <Box position="absolute" display="flex" gap={2} top={700} left={77}>
                    <SocialIcon
                        icon={
                            <img
                                src={instagramIcon}
                                alt="Instagram"
                                style={{ width: 30, height: 30 }}
                            />
                        }
                        src="https://www.instagram.com/indmatrimony/"
                    />
                    <SocialIcon
                        icon={
                            <img
                                src={whatsAppIcon}
                                alt="WhatsApp"
                                style={{ width: 25, height: 25 }}
                            />
                        }
                        src="https://wa.me/918600555740"
                    />
                    <SocialIcon
                        icon={
                            <img
                                src={wwwIcon}
                                alt="Website"
                                style={{ width: 30, height: 30 }}
                            />
                        }
                        src="https://indmatrimony.in/"
                    />
                    <SocialIcon
                        icon={
                            <img
                                src={facebookIcon}
                                alt="Facebook"
                                style={{ width: 30, height: 30 }}
                            />
                        }
                        src="https://www.facebook.com/indmatrimonyofficial/"
                    />
                </Box>

                <Box
                    position="absolute"
                    width={307}
                    top={770}
                    left={6}
                    display="flex"
                    alignItems="flex-start"
                    gap={1}
                >
                    <img
                        src={locationIcon}
                        alt="Place marker"
                        style={{
                            width: "21px",
                            height: "25px",
                            flexShrink: 0,
                            marginTop: "2px" // Optional: Adjust to align with first line of text
                        }}
                    />
                    <Typography
                        fontFamily="Montserrat, sans-serif"
                        fontWeight="500"
                        color="#555454"
                        fontSize={10}
                        sx={{
                            textIndent: 0,
                            paddingLeft: 0,
                            marginLeft: 2,
                            whiteSpace: "pre-wrap",
                            wordWrap: "break-word",
                            textAlign: "left"
                        }}
                    >
                        Plot No. 35, Empress Mill Colony, Srinagar, Narendra Nagar, In front of Little Millennium School, Nagpur – 440015
                    </Typography>
                </Box>

            </Box>
        </Box>
    );
};
